import { User } from '../models/User';
import { Api } from '../api';
import { store } from '../app/store';
import { sessionActions } from '../app/session/actions';

export class UserHelper {
  public static fetchUser(): Promise<User> {
    return Api.currentUser()
      .then(response => new User(response));
  }

  public static async fetchAndStoreUser(): Promise<User> {
    const user = await UserHelper.fetchUser();
    store.dispatch(sessionActions.setUser(user.toSingleUser()));
    const dossiers = await Api.listUserDossiers();
    store.dispatch(sessionActions.setMultiDossierUser(dossiers.length > 1));
    return user;
  }
}
